import {
  CREATE_POD,
  CREATE_POD_FAILURE,
  CREATE_POD_SUCCESS,
  DELETE_POD,
  DELETE_POD_FAILURE,
  DELETE_POD_SUCCESS,
  GET_POD,
  GET_POD_FAILURE,
  GET_POD_SUCCESS,
  PERMANENT_POD_RETENTION,
  UPDATE_POD,
  UPDATE_POD_CONFIG,
  UPDATE_POD_CONFIG_FAILURE,
  UPDATE_POD_CONFIG_SUCCESS,
  UPDATE_POD_FAILURE,
  UPDATE_POD_SUCCESS,
} from "../../constants/types";
import instance from "../../services/axiosConfig";
import { parseError } from "./ActionHelpers";

export const getPODs = (onSuccess) => async (dispatch) => {
  dispatch({ type: GET_POD });
  try {
    const { data } = await instance.get("/delivery-rules/account-rules");
    const pods = data.sort((item1, item2) => {
      if (item1.name < item2.name) return 1;
      if (item1.name > item2.name) return -1;
      return 0;
    });
    const { data: configs } = await instance
      .get("/delivery-rules/account-delivery-configs")
      .catch(async (err) => {
        if (err.response?.status === 404) {
          return await instance.post(
            "/delivery-rules/account-delivery-configs",
            {
              require_pod_approval: false,
              require_signature: false,
              require_parcel_photo: false,
              allow_extra_pods: false,
              pod_retention_policy: PERMANENT_POD_RETENTION,
            },
          );
        }
        throw err;
      });
    dispatch({
      type: GET_POD_SUCCESS,
      payload: { pods, configs },
    });
    if (onSuccess) onSuccess({ pods, configs });
  } catch (err) {
    console.log("Error: ", err);
    const errMsg = parseError(err);
    dispatch({
      type: GET_POD_FAILURE,
      payload: errMsg,
    });
  }
};

export const createPODs = (data, onSuccess) => (dispatch) => {
  dispatch({ type: CREATE_POD });
  instance
    .post("/delivery-rules/account-rules", data)
    .then((res) => {
      dispatch({
        type: CREATE_POD_SUCCESS,
        payload: res.data,
      });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      console.log("Error: ", err);
      const errMsg = parseError(err);
      dispatch({
        type: CREATE_POD_FAILURE,
        payload: errMsg,
      });
    });
};

export const updatePODs = (id, data, onSuccess) => (dispatch) => {
  dispatch({ type: UPDATE_POD });
  instance
    .patch(`/delivery-rules/account-rules/${id}`, data)
    .then((res) => {
      dispatch({
        type: UPDATE_POD_SUCCESS,
        payload: res.data,
      });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      console.log("Error: ", err);
      const errMsg = parseError(err);
      dispatch({
        type: UPDATE_POD_FAILURE,
        payload: errMsg,
      });
    });
};

export const deletePODs = (id, onSuccess) => (dispatch) => {
  dispatch({ type: DELETE_POD });
  instance
    .delete(`/delivery-rules/account-rules/${id}`)
    .then((res) => {
      dispatch({
        type: DELETE_POD_SUCCESS,
        payload: id,
      });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      console.log("Error: ", err);
      const errMsg = parseError(err);
      dispatch({
        type: DELETE_POD_FAILURE,
        payload: errMsg,
      });
    });
};

export const updatePODConfig = (data, onSuccess) => (dispatch) => {
  dispatch({ type: UPDATE_POD_CONFIG });
  instance
    .patch("/delivery-rules/account-delivery-configs", data)
    .then((res) => {
      dispatch({
        type: UPDATE_POD_CONFIG_SUCCESS,
        payload: res.data,
      });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      console.log("Error: ", err);
      const errMsg = parseError(err);
      dispatch({
        type: UPDATE_POD_CONFIG_FAILURE,
        payload: errMsg,
      });
    });
};
